import React from 'react';
import { nothingEvent } from '../../types/Reigenspf001';


/**
 * 未申込/申込済みのイベントが無かった際に表示するコンポーネント
 * @param props 未申込か申込済みかの真偽値
 * @returns
 */

export function NothingEvent(props: nothingEvent) {
    return (
      <div className="no-record">
        {props.isSubmitted ? "申込済み": "未申込"}のイベントはありません
      </div>
      );

  }